// Setup carousel elements
import { Swiper, Navigation, EffectFade } from 'swiper';

Swiper.use([Navigation, EffectFade]);

(() => {
  const changeBackgroundColor = (swiper, selectors) => {
    const { colour } = swiper.slides[swiper.activeIndex].dataset;
    if (colour) {
      const elements = document.querySelectorAll(selectors);
      elements.forEach(el => {
        const previousColour = el.dataset.currentColour;
        if (previousColour) {
          el.classList.remove(`bg-${previousColour}`);
        }
        el.classList.add(`bg-${colour}`);
        el.setAttribute('data-current-colour', colour);
      });
    }
  };
  // eslint-disable-next-line no-new
  new Swiper('#swiper-templates', {
    loop: true,
    speed: 400,
    slidesPerView: 'auto',
    autoHeight: true,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    preventInteractionOnTransition: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: {
        spaceBetween: -88,
      },
      720: {
        spaceBetween: 0,
      },
    },
    on: {
      slideChange(swiper) {
        changeBackgroundColor(swiper, ['.section-templates']);
      },
      init(swiper) {
        changeBackgroundColor(swiper, ['.section-templates']);
      },
    },
  });

  // eslint-disable-next-line no-new
  new Swiper('#swiper-checkouts', {
    loop: false,
    speed: 400,
    slidesPerView: 1,
    spaceBetween: 6,
    autoHeight: true,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    preventInteractionOnTransition: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
})();
